const $ = require('jquery');

module.exports = (el, zoom, w, h)=>{

    // exist element only
    if($(el).length === 0) return;

    var centerPosition = new google.maps.LatLng(35.623631, 139.722956);
    var option = {
        zoom: zoom,
        center: centerPosition,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
    };
    var googlemap = new google.maps.Map(document.getElementById("google_map"), option);
    var icon = new google.maps.MarkerImage('/assets/img/company/access_map_icon.png',
        new google.maps.Size(w, h), /*アイコンサイズ設定*/
        new google.maps.Point(0, 0) /*アイコン位置設定*/
    );
    var styleOptions = [{
        'stylers': [{
            'gamma': 0.8
        }, {
            'saturation': -100
        }, {
            'lightness': 20
        }]
    }];

    var monoType = new google.maps.StyledMapType(styleOptions );
    googlemap.mapTypes.set('mono', monoType);
    googlemap.setMapTypeId('mono');
    var markerOptions = {
        position: centerPosition,
        map: googlemap,
        icon: icon,
        title: 'test'
    };

    var marker = new google.maps.Marker(markerOptions);
}
